import { render, staticRenderFns } from "./InsPage.vue?vue&type=template&id=79a1e4a8&scoped=true&"
import script from "./InsPage.vue?vue&type=script&lang=js&"
export * from "./InsPage.vue?vue&type=script&lang=js&"
import style0 from "./InsPage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./InsPage.vue?vue&type=style&index=1&id=79a1e4a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a1e4a8",
  null
  
)

export default component.exports